import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { map, Observable, Subject } from 'rxjs';
import { NotificationService } from '../../../../services/notifications.service';
import { BaseService } from '../../../../services/base.service';
import { initItemsParams } from '../../../../services/channel.service';
import { MatDialog } from '@angular/material/dialog';
import { IntegrationService } from '../../../../services/integration.service';
import { ModalService } from '../../../../services/modal.service';
import { AppTableSource, ColumnSortType } from '../../../../model/table.model';
import { tableHeaders } from './my-templates.interface';
import { IParams } from '../../../../model/http';
import { OlxAdvertService } from '../../../../services/olx-advert.service';
import { SelectionModel } from '@angular/cdk/collections';
import { parseCurrencyXXX } from '../../../../helpers';

@Component({
  selector: 'app-my-adverts-templates',
  templateUrl: './my-templates.component.html',
  styleUrls: ['./my-templates.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MyTemplatesComponent implements OnInit, OnDestroy {
  // Destroy relative
  private readonly destroy$: Subject<null> = new Subject<null>();
  dataSource$: Observable<AppTableSource> = this.olxAdvertService.items$.pipe(
    map((data) => {
      tableHeaders.map((column) => {
        column.sort = ColumnSortType.NONE;
        if (column.value === this.dataSort?.active) {
          column.sort = this.dataSort.direction;
        }
        return column;
      });
      return {
        headers: tableHeaders,
        rows: data.items.map((v: any) => {
          return {
            ...v,
            price_value: parseCurrencyXXX(v.price?.value, v.price?.currency),
            contact_name: v.contact?.name,
            contact_phone: v.contact?.phone,
          };
        }),
        pageSize: data?.size || 0,
        pageIndex: data.page ? data.page - 1 : 0,
        length: data.total || 0,
      };
    }),
  );
  visibleColumns = tableHeaders.map((v) => v.value);
  selectionTable = new SelectionModel<any>(true, []);

  public bulkActionList: any[] = [
    { label: 'Активувати зараз', value: 'ACTIVE_NOW' },
    { label: 'Деактивувати зараз', value: 'DEACTIVATE_NOW' },
    { label: 'Запланувати активацію', value: 'ACTIVE_PLANNER' },
  ];

  private itemsRequest: any;
  private dataSort: any;
  public isLoader: boolean = false;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly integrationService: IntegrationService,
    private readonly baseService: BaseService,
    private readonly olxAdvertService: OlxAdvertService,
    private readonly dialog: MatDialog,
    private readonly modalService: ModalService,
  ) {}

  getItemsWithUpdatedParams(params: IParams, isLoader = false) {
    if (this.itemsRequest) {
      this.itemsRequest.unsubscribe();
    }
    this.isLoader = isLoader;
    this.selectionTable.clear();
    // this.itemsRequest = this.olxAdvertService
    //   .setQueryItemsParams(this.currentOlxAccount, params)
    //   .pipe(takeUntil(this.destroy$), take(1))
    //   .subscribe({
    //     next: (res) => {
    //       this.isLoader = false;
    //       this.loadPlanners(res.items.map((v: any) => v.id));
    //       if (!res.items.length && res.page > 1) {
    //         this.getItemsWithUpdatedParams({
    //           page: res.page - 1,
    //           take: res.take
    //         }, true);
    //       }
    //     },
    //     error: () => {
    //       this.isLoader = false;
    //     }
    //   });
  }

  ngOnInit() {
    this.isLoader = true;
    // this.olxAdvertService.getIntegrationOlx()
    //   .pipe(takeUntil(this.destroy$), take(1))
    //   .subscribe({
    //     next: (res) => {
    //       this.items = res;
    //       this.onValueChange(res[0] || null);
    //       this.olxAdvertService.loadItems(this.currentOlxAccount)
    //         .pipe(takeUntil(this.destroy$), take(1))
    //         .subscribe({
    //           next: () => {
    //             this.isLoader = false;
    //           },
    //           error: () => {
    //             this.isLoader = false;
    //           }
    //         });
    //     },
    //     error: () => {
    //       this.isLoader = false;
    //     }
    //   });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  onSortChange(sortState: any) {
    this.dataSort = sortState;
    this.getItemsWithUpdatedParams({
      sort: sortState.active,
      order: sortState.direction,
    });
  }

  onPaginationChange(paginationDetails: any) {
    const { pageIndex, pageSize } = paginationDetails;
    const page = pageIndex + 1;
    const take = pageSize;
    this.getItemsWithUpdatedParams({ page, take }, true);
  }

  onActionChange(event: any) {}

  timerSearch: any;

  onSearchChange(search: string) {
    if (this.timerSearch) clearTimeout(this.timerSearch);
    this.timerSearch = setTimeout(() => {
      this.getItemsWithUpdatedParams(
        {
          ...initItemsParams,
          search,
        },
        true,
      );
    }, 500);
  }

  onValueChange(event: any) {
    this.getItemsWithUpdatedParams({}, true);
  }

  bulkActionPopup(event: any) {}

  onFilterChange(event: string, item: any) {
    this.getItemsWithUpdatedParams({
      filters: { status: item?.value },
    });
  }

  protected readonly Object = Object;
}
